import { Avatar, Chip } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';

interface UserChipProps {
  user: {
    id: string;
    email: string;
    firstName: string | null;
    lastName: string | null;
    avatarUrl?: string | null;
  } | null;
  clickable?: boolean;
}

export default function UserChip({ user, clickable = true }: UserChipProps) {
  const navigate = useNavigate();

  if (!user) {
    return (
      <Chip
        label="N/A"
        size="small"
        sx={{
          fontSize: '0.75rem',
        }}
      />
    );
  }

  const userName =
    user.firstName && user.lastName ? `${user.firstName} ${user.lastName}` : user.email;

  const userInitials =
    user.firstName && user.lastName
      ? `${user.firstName[0]}${user.lastName[0]}`.toUpperCase()
      : user.email[0].toUpperCase();

  return (
    <Chip
      avatar={
        <Avatar src={user.avatarUrl || undefined} sx={{ width: 24, height: 24, fontSize: '0.75rem' }}>
          {userInitials}
        </Avatar>
      }
      label={userName}
      size="small"
      onClick={clickable ? () => navigate(`/app/users/${user.id}`) : undefined}
      sx={{
        cursor: clickable ? 'pointer' : 'default',
        fontSize: '0.75rem',
        ...(clickable && {
          '&:hover': {
            backgroundColor: 'action.hover',
          },
        }),
      }}
    />
  );
}
